import { Heading, Stack } from '@react/chakra';

import type { JSX } from 'react';

export function Empty(): JSX.Element {
  return (
    <Stack>
      <Heading>I haven&apos;t published anything!</Heading>
      <Heading>Come back later!</Heading>
    </Stack>
  );
}
